(() => {
  function formatFund(root) {
    root.querySelectorAll('.art-fund').forEach((fund) => {
      fund.querySelectorAll('p,h2').forEach((element) => {
        if (!element.textContent.replace(/[\s\u200b\u00a0]/g, '') && !element.querySelector('img,video,iframe')) element.remove();
      });
      const vogel = fund.querySelector('.art-fund__vogel-copy');
      if (vogel && !vogel.dataset.fundFormatted) {
        vogel.dataset.fundFormatted = 'true';
        let previous = null;
        [...vogel.children].forEach((element) => {
          if (element.tagName !== 'P' || /^https?:\/\//i.test(element.textContent.trim())) { previous = null; return; }
          if (previous) {
            previous.append(document.createTextNode(' '), ...element.childNodes);
            element.remove();
          } else previous = element;
        });
      }
      fund.querySelectorAll('.art-fund__press a').forEach((link) => {
        // Duplicate printed URLs are redundant beside the original article headline.
        if (/^https?:\/\//i.test(link.textContent.trim())) link.hidden = true;
      });
      fund.querySelectorAll('.art-fund__copy p').forEach((paragraph) => {
        if (paragraph.dataset.fundFormatted) return;
        paragraph.dataset.fundFormatted = 'true';
        // Old Wix line-breaks included empty spacer lines inside paragraphs.
        paragraph.querySelectorAll('br + br').forEach((br) => br.remove());
      });
    });
  }
  formatFund(document);
  document.addEventListener('shopify:section:load', (event) => formatFund(event.target));
})();
